@import '../../common/common.scss';

:host {
  display: flex;
  flex-direction: column;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}
